/**
 * Fade Switch Video Lazy Loading Fix
 * Fixes the issue where sectionsTT.min.js uses data() which doesn't work with underscores
 * and implements true lazy loading using Intersection Observer
 * Adds mobile autoplay support matching sectionsTT.min.js behavior
 */
(function() {
  'use strict';

  function loadVideoSource($video, isMobile, callback) {
    const videoEl = $video[0];
    
    // Skip if already has source
    if (videoEl.querySelector("source")) {
      if (callback) callback(videoEl);
      return true; // Already loaded
    }
    
    // Fix: Use attr() instead of data() to get the actual attribute value
    // jQuery's data() converts data-src_pc to srcPc (camelCase), not src_pc
    let src = "";
    if (isMobile) {
      src = $video.attr("data-src-mb") || $video.attr("data-src_mb") || "";
    } else {
      src = $video.attr("data-src-pc") || $video.attr("data-src_pc") || "";
    }
    
    if (src) {
      const source = document.createElement("source");
      source.src = src;
      source.type = "video/mp4";
      videoEl.appendChild(source);
      videoEl.load();
      
      $video.off("canplay").one("canplay", function() {
        videoEl.play();
        if (callback) callback(videoEl);
      });
      
      return true; // Source added
    }
    
    return false; // No source to load
  }
  
  // Expose function globally for sectionsTT.min.js compatibility
  window.loadVideoSource = loadVideoSource;
  
  $(document).ready(function() {
    $(".fade-switch-video").each(function() {
      const $section = $(this);
      const $videos = $section.find("video");
      const isMobile = $(window).innerWidth() <= 768;
      
      // Use Intersection Observer for true lazy loading
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const $video = $(entry.target);
            const videoEl = entry.target;
            const $videoCon = $video.closest(".video-con");
            
            // Load video source
            loadVideoSource($video, isMobile, function(video) {
              // Mobile autoplay: match sectionsTT.min.js behavior
              
                // Add play class to video-con (not video-item) for button state
                $videoCon.addClass("play");
              
              // Sync button state with video play/pause events
              $(video).on("play", function() {
                $videoCon.find(".video-poster").hide();
              });
            });
            
            // Stop observing once loaded
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '50px' // Start loading 50px before entering viewport
      });
      
      // Observe all videos for lazy loading
      $videos.each(function() {
        observer.observe(this);
      });
    });
  });
})();

